import React, { useContext } from "react";

import Toolbar from "Trackalyze/Toolbar";
import { useTranslation } from "react-i18next";

import Flex, { FlexItem } from "Trackalyze/Flex";
import FilterActivities from "./FilterActivities";
import FilterWaypoints from "./FilterWaypoints";
import FilterFavorites from "./FilterFavorites";
import FilterGpxTypes from "./FilterGpxTypes";
import FilterGroups from "./FilterGroups";
import { FilteredTracksContext } from "~/Context/FilteredTracksContext";
import Button from "Trackalyze/Button";
import List from "Trackalyze/List";

const Filter = (props) => {
  const { t } = useTranslation();
  const {
    filterActivities,
    setFilterActivities,
    filterWaypoints,
    setFilterWaypoints,
    filterFavorites,
    setFilterFavorites,
    filterGpxTypes,
    setFilterGpxTypes,
    filterGroups,
    setFilterGroups,
  } = useContext(FilteredTracksContext);

  const handleReset = () => {
    switch (props.activeFilter) {
      case "activities":
        setFilterActivities([]);
        break;
      case "waypoints":
        setFilterWaypoints([]);
        break;
      case "favorites":
        setFilterFavorites([]);
        break;
      case "gpxtypes":
        setFilterGpxTypes([]);
        break;
      case "groups":
        setFilterGroups([]);
        break;
      default:
        setFilterActivities([]);
        setFilterWaypoints([]);
        setFilterFavorites([]);
        setFilterGpxTypes([]);
        setFilterGroups([]);
        break;
    }
  };

  const isResetDisabled = () => {
    switch (props.activeFilter) {
      case "activities":
        return filterActivities.length === 0;
      case "waypoints":
        return filterWaypoints.length === 0;
      case "favorites":
        return filterFavorites.length === 0;
      case "gpxtypes":
        return filterGpxTypes.length === 0;
      case "groups":
        return filterGroups.length === 0;
      default:
        return (
          filterActivities.length === 0 &&
          filterWaypoints.length === 0 &&
          filterFavorites.length === 0 &&
          filterGpxTypes.length === 0 &&
          filterGroups.length === 0
        );
    }
  };

  const renderContent = () => {
    switch (props.activeFilter) {
      case "activities":
        return <FilterActivities standalone />;
      case "waypoints":
        return <FilterWaypoints standalone />;
      case "favorites":
        return <FilterFavorites standalone />;
      case "gpxtypes":
        return <FilterGpxTypes standalone />;
      case "groups":
        return <FilterGroups standalone />;
      default:
        return (
          <List segmented level="3">
            <FilterWaypoints />
            <FilterFavorites />
            <FilterGpxTypes />
            <FilterActivities />
            <FilterGroups />
          </List>
        );
    }
  };

  const getTitle = () => {
    switch (props.activeFilter) {
      case "activities":
        return t("trackManager.filterOptionsActivities");
      case "waypoints":
        return t("trackManager.filterOptionsWaypoints");
      case "favorites":
        return t("trackManager.filterFavorites");
      case "gpxtypes":
        return t("trackManager.filterOptionsGpxtypes");
      case "groups":
        return t("trackManager.filterOptionsGroups");
      default:
        return t("trackManager.filterTitle");
    }
  };

  return (
    <Flex vertical className="ta-surface_ta-surface--1 ta-height_full">
      <Toolbar
        title={getTitle()}
        onClose={() => props.onClose && props.onClose()}
      >
        <Button disabled={isResetDisabled()} onClick={handleReset}>
          Reset
        </Button>
      </Toolbar>
      <FlexItem className="ta-is-overflow">
        <Flex
          flexitem
          className="ta-hack_maxheight ta-padding_xs ta-is-overflow"
          vertical
        >
          {renderContent()}
        </Flex>
      </FlexItem>
    </Flex>
  );
};

export default React.memo(Filter);
